import React from "react";
import {
  Row,
  Col,
  Flex,
  Statistic,
  Table,
  Tag,
  Typography,
  Progress,
  Space,
  Button,
  Grid, // <- added
} from "antd";
import { useNavigate } from "react-router-dom";
const { Title, Text } = Typography;

// ── Component ──────────────────────────────────────────
const Dashboard = () => {
  const screens = Grid.useBreakpoint(); // <- added
  const navigate = useNavigate(); // <- added
  const alignment = screens.md ? "left" : "center"; // più padding su schermi più grandi

  return (
    <Space direction="vertical" size={24} style={{ width: "100%" }}>
      {/* ── Hero banner with orange background ── */}
      <div style={{ position: "relative", height: "100vh" }}>
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "white",
            zIndex: 0,
          }}
        />
        <div style={{ position: "relative", zIndex: 1 }}>
          <div
            style={{
              background: "linear-gradient(135deg, #f9b27fff, #ff8c00)",
              height: "100px",
              maxHeight: "100px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",

              boxShadow: "0 4px 20px rgba(255, 106, 0, 0.3)",
            }}
          >
            {/* Left: title */}
            <div style={{ alignItems: "center", justifyContent: "center" }}>
              <Title
                level={1}
                style={{
                  color: "#fff",
                  //margin: 0,
                  letterSpacing: "-0.4px",
                  fontSize: screens.md ? 58 : 32,
                }}
              >
                PappaPiano
              </Title>
            </div>
          </div>
          <div
            style={{
              backgroundImage: 'url("/assets/disegnoiniziale.png")',
              backgroundSize: screens.md ? "contain" : "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              marginTop: "0px",
              height: "calc(100vh - 100px)",
            }}
          >
            <Row
              id="mainHome"
              justify="center"
              style={{
                paddingTop: "250px",
              }}
            >
              <Col
                xs={24}
                md={20}
                lg={16}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: 16,
                    flexWrap: "wrap",
                    justifyContent: "center",
                    marginTop: screens.md ? "100px" : "0px",
                    width: "100%",
                  }}
                >
                  <Button
                    color="default"
                    variant="solid"
                    id="startTrainingButton"
                    style={{
                      color: "#FFF",
                      background: "#F4A261",
                      padding: 60,
                      fontSize: 40,
                      fontWeight: "bold",
                      borderColor: "#CCC",
                    }}
                    onClick={() => navigate("/PappaTime")}
                  >
                    Pappa Time!
                  </Button>
                  <Button
                    color="default"
                    variant="solid"
                    style={{
                      color: "#FFF",
                      background: "#95ADF0",
                      padding: 60,
                      fontSize: 40,
                      fontWeight: "bold",
                      borderColor: "#CCC",
                    }}
                    onClick={() => navigate("/informazioni")}
                  >
                    Il Progetto
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </Space>
  );
};

export default Dashboard;
